import { useState } from 'react'
import {
  IBankCollectorAccount,
  ICollectorAccountCodes,
} from '../../../../common/interfaces/bankPaymentCode.interface'
import { CancelButton, CodeValue, EditButton } from './CodeActions'
import { SaveButton } from './SaveButton'

interface IProps {
  account: IBankCollectorAccount
  bankEnabled: boolean
  saving: boolean
  onSave: (accountId: number, fundTitle: string, codes: ICollectorAccountCodes) => Promise<boolean>
}

const MISSING_FUND_HABITAT_CODE_HINT =
  'Este fondo no generará código de pago aunque el banco esté habilitado. Registre su código Habitat.'

export const CollectorAccountRow = ({ account, bankEnabled, saving, onSave }: IProps) => {
  const [editing, setEditing] = useState(false)
  const [habitatCode, setHabitatCode] = useState('')

  const trimmedHabitatCode = habitatCode.trim()
  const canSave =
    !!trimmedHabitatCode && trimmedHabitatCode !== (account.habitat_product_code ?? '')

  const startEditing = () => {
    setHabitatCode(account.habitat_product_code ?? '')
    setEditing(true)
  }

  const save = async () => {
    if (await onSave(account.id, account.fund_title, { habitat_product_code: trimmedHabitatCode }))
      setEditing(false)
  }

  return (
    <tr>
      <td className='text-gray-800'>{account.fund_title}</td>
      <td>
        <CodeValue value={account.id_spectrum_bank} />
      </td>
      <td>
        {editing ? (
          <input
            className='form-control form-control-sm'
            aria-label={`Código Habitat de ${account.fund_title}`}
            value={habitatCode}
            onChange={(e) => setHabitatCode(e.target.value)}
          />
        ) : (
          <CodeValue
            value={account.habitat_product_code}
            missingWarning={
              bankEnabled
                ? {
                    label: `Por qué ${account.fund_title} no genera código de pago`,
                    message: MISSING_FUND_HABITAT_CODE_HINT,
                  }
                : undefined
            }
          />
        )}
      </td>
      <td className='text-end'>
        {editing ? (
          <div className='d-flex justify-content-end gap-2'>
            <CancelButton disabled={saving} onClick={() => setEditing(false)} />
            <SaveButton
              ariaLabel={`Guardar código Habitat de ${account.fund_title}`}
              disabled={!canSave}
              saving={saving}
              onClick={save}
            />
          </div>
        ) : (
          <EditButton
            ariaLabel={`Editar código Habitat de ${account.fund_title}`}
            onClick={startEditing}
          />
        )}
      </td>
    </tr>
  )
}
